import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '~components';
import Modal from '~components/Modal';
import SelectLazy from '~components/form-fields/inputs/SelectLazy';

import { getAll as getClients } from '~main/actions/clients';
import { selectLookupClients } from '~main/selectors/clients/clients';

interface ComponentProps {
  templateId: string | undefined;
  isOpen: boolean;
  onCancel: () => void;
}

const ClientPickerModal: React.FC<ComponentProps> = ({ templateId, isOpen, onCancel }) => {
  const navigate = useNavigate();
  const [clientId, setClientId] = useState<number | null>(null);

  // Reset selection whenever the modal is reopened for a different template.
  useEffect(() => {
    if (isOpen) setClientId(null);
  }, [isOpen, templateId]);

  const handleClientChange = (_name: string, value: number | null) => setClientId(value);

  const handleConfirm = () => {
    if (clientId === null || !templateId) return;
    navigate(`/forms/templates/${templateId}/fill?clientId=${clientId}`);
    onCancel();
  };

  const setIsOpen = (open: boolean) => {
    if (!open) onCancel();
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      header="Select Client"
      includeFooter={false}
      backdrop="static"
    >
      <div className="d-flex flex-column gap-2">
        <label htmlFor="forms-client-picker" className="fw-semibold">
          Client
        </label>
        <SelectLazy
          type="select-lazy"
          id="forms-client-picker"
          name="client_id"
          value={clientId ?? undefined}
          placeholder="Search clients…"
          selectorOptions={selectLookupClients}
          selectorActions={getClients}
          manualReload
          onChange={handleClientChange}
        />
        <div className="d-flex justify-content-end gap-2 mt-3">
          <Button
            id="forms-client-picker-cancel"
            data-cy="forms-client-picker-cancel"
            color="info"
            outline
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            id="forms-client-picker-confirm"
            data-cy="forms-client-picker-confirm"
            color="success"
            onClick={handleConfirm}
            disabled={clientId === null}
          >
            Fill Form
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ClientPickerModal;
